import React, { Fragment, useState } from 'react';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';

const UpsShipmentForm = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="UPS Shipments"
        headerText="UPS Shipments"
      >
        <Form closeModal={closeModal} />
      </Modal>

      <button
        onClick={openModal}
        type="button"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#7c3aed',
          color: 'white',
          height: '42px',
          padding: '0 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
          <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"/>
          <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2.05a2.5 2.5 0 014.9 0H18a1 1 0 001-1v-2a1 1 0 00-.293-.707l-3-3A1 1 0 0015 3h-4a1 1 0 00-1 1v3H4a1 1 0 00-1-1zm8 0h4l3 3v2h-7V4z"/>
        </svg>
        UPS Shipments
      </button>
    </Fragment>
  );
};

export default UpsShipmentForm;
